module.exports = __webpack_public_path__ + "static/media/greco_f_thumb.0921da15.jpg";